/**
 * Format a date string to a readable format
 */
export const formatDate = (dateString?: string): string => {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return 'N/A';
        }
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'N/A';
    }
};

export const formatDuration = (startTime: string, endTime: string): string => {
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return 'N/A';
    }
    const duration = endDate.getTime() - startDate.getTime();
    const durationDays = Math.ceil(duration / (1000 * 60 * 60 * 24));
    return `${durationDays} Days`;
};

/**
 * Error handling utilities - only active in development mode
 */
export const setupErrorHandlers = () => {
    if (import.meta.env.APP_ENV !== 'development') {
        return; // Only run in development
    }

    // Global JavaScript error handler
    window.addEventListener('error', (event) => {
        console.error('🚨 Global Error:', event.error);
        console.error('Error Message:', event.message);
        console.error('Error Source:', event.filename, 'Line:', event.lineno, 'Column:', event.colno);
        console.error('Error Stack:', event.error?.stack);
    });

    // Unhandled promise rejection handler
    window.addEventListener('unhandledrejection', (event) => {
        console.error('🚨 Unhandled Promise Rejection:', event.reason);
        console.error('Promise Rejection Stack:', event.reason?.stack);
    });

    // Enhanced React error logging
    const originalConsoleError = console.error;
    // TODO: type this - Overriding console.error signature requires matching its exact parameter types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    console.error = (...args: any[]) => {
        // Log React errors with a clear marker
        if (args[0]?.includes?.('Error:') || args[0]?.includes?.('Warning:')) {
            console.group('%c🚨 React Error/Warning', 'color: red; font-weight: bold; font-size: 14px;');
            originalConsoleError(...args);
            console.groupEnd();
        } else {
            originalConsoleError(...args);
        }
    };

    // Development mode indicator
    console.log('%c🔍 Development Mode: Enhanced Error Logging Enabled', 'color: #D4024B; font-weight: bold;');
    console.log('%c💡 Tip: All errors are now logged with clear markers. Check the console for detailed error information.', 'color: #666; font-size: 12px;');
};
